export class CurtainDirection {
	static up: string = "CurtainUp";
	static down: string = "CurtainDown";
}